import * as React from 'react';
import { Grid, StyledComponentProps, withStyles } from '@material-ui/core';
import TextField from '../../../../ui-components/TextField/TextField';
import Button from '../../../../ui-components/Button/Button';
import { styles } from './styles';

interface IProps extends StyledComponentProps {
    handleChangeFullnameOrEmail: (val: string) => void;
    search: (page: number, fullnameOrEmail: string) => void;
    fullnameOrEmail: string;
}

class Filters extends React.Component<IProps>
{

    render() {
        const classes = this.props.classes;
        return (<Grid container xs={12} className={classes.root} spacing={2}>
            <Grid item style={{flexGrow: 9}}>
                <Grid container spacing={2}>
                    <Grid item xs={12} >
                        <TextField label={"Filtro"} 
                        placeholder='Cognome o Email'
                        onKeyDown={(e) => {
                            //Enter KeyCode = 13
                            if (e.keyCode === 13) {
                                this.props.search(0, this.props.fullnameOrEmail)
                            }
                        }}
                         onChange={this.props.handleChangeFullnameOrEmail} value={this.props.fullnameOrEmail} />
                    </Grid>
                </Grid>
            </Grid>
            <Grid item  className={classes.searchButtonContainer} >
                <Button className={classes.searchButton} onClick={() => this.props.search(0, this.props.fullnameOrEmail)}>Cerca</Button>
            </Grid>
        </Grid>
        );
    }
}

export default withStyles(styles)(Filters)